import http from "./http";

//获取反馈列表
export const getAllDoc = async (data) => {
    return await http.get(`doc/getAllDoc`, data);
};
//更新用户协议
export const updateUserAgreement = async (data) => {
    return await http.post(`/doc/updateUserAgreement`, data);
};
//更新隐私政策
export const updatePrivacyPolicy = async (data) => {
    return await http.post(`/doc/updatePrivacyPolicy`, data);
};
//更新帮助信息
export const updateHelp = async (data) => {
    return await http.post(`/doc/updateHelp`, data);
};
//更新公司信息
export const updateCompanyInfo = async (data) => {
    return await http.post(`/doc/updateCompanyInfo`, data);
};
//更新贴士信息
export const updateTip = async (data) => {
    return await http.post(`/doc/updateTip`, data);
};